import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { KioskListModel } from 'src/app/shared/models/KioskListModel.model';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { KioskModel } from 'src/app/shared/models/KioskModel.model';
@Injectable({
  providedIn: 'root'
})
export class KioskService {

  private userToken: string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }

  public GetKioskByIpAddress(): Observable<any> {

    const $this = this;

    return $this.http.get<any>(environment.apiUrl + 'api/v1/Kiosk/GetKioskByIpAddress/' + location.host).pipe();
  }

  public GetAllColumnNames(): Observable<string[]> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.get<string[]>(environment.apiUrl + 'api/v1/Kiosk/GetAllColumnNames', header).pipe();
  }

  public GetAllKiosks(filterParameters: FiltersModel): Observable<KioskListModel> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.post<KioskListModel>(environment.apiUrl + 'api/v1/Kiosk/GetAllKiosks', filterParameters, header).pipe();
  }

  public DeleteListOfKiosks(listOfDocuments: any[]): Observable<any> {
    const $this = this;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + $this.userToken),
      body: listOfDocuments,
    };
    return $this.http.delete<any>(environment.apiUrl + 'api/v1/Kiosk', options).pipe();
  }

  public GetKioskById(id:number): Observable<KioskModel>{
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization',  'Bearer ' + $this.userToken)
    }

    return $this.http.get<KioskModel>(environment.apiUrl + 'api/v1/Kiosk/' + id, header).pipe();
  }

  public SaveKiosk(argKioskData: KioskModel): Observable<string> {

    const $this = this;

    return $this.http.post<string>(environment.apiUrl + 'api/v1/Kiosk', argKioskData).pipe();

  }
}
